import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const ReasonModal = ({
  open,
  loading,
  editReason,
  setEditReason,
  handleClose,
  handleSaveEditReason,
}) => {
  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle>Edit Reason</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          multiline
          minRows={4}
          fullWidth
          variant="outlined"
          label="Reason"
          value={editReason}
          onChange={(e) => setEditReason(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>

        <Button
          variant="contained"
          color="primary"
          endIcon={!loading && <SendIcon />}
          onClick={handleSaveEditReason}
          disabled={loading || !editReason?.trim()}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            "Update Reason"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReasonModal;
